<template>
  <div>
    <button  v-on:click.prevent="showSmsDesc = !showSmsDesc">SMS-код долго не приходит?</button>
    <ul class="stxt" v-if="showSmsDesc">
      <li>Время доставки SMS может занять несколько минут.</li>
      <li>Если возникают проблемы с доставкой SMS-сообщений:</li>
      <li>- <button v-on:click="repeatSms">Отправить SMS повторно</button></li>
      <li>- Если сообщение не приходит - значит могут наблюдаться проблемы у мобильного оператора или переполнена
        память телефона.
      </li>
    </ul>
  </div>

</template>

<script>
  const maxTimeSmSDelay=60;
  export default {
    name: "smsInfo",
    data(){
      return {
        smsCountdown:-1,
        showSmsDesc:false,
      }
    },
    methods:{
      repeatSms(){
        if ( this.smsCountdown <= 0) {
          let time = new Date;
          localStorage.setItem('lastTimeSmSSend', time.getTime());
          this.canReSendSms();
          this.$emit('repeatSms');
        } else {
          alert('повторное смс можно отправить через '+this.smsCountdown +' секунд');
        }
      },
      countdownAction() {
        if (this.smsCountdown > 0) {
          this.interlvalID = setTimeout(() => {
            this.smsCountdown -= 1;
            this.countdownAction();
          }, 1000);
        }
      },
      canReSendSms() {
        let time = new Date;
        if (localStorage.getItem('lastTimeSmSSend') == null) {
          localStorage.setItem('lastTimeSmSSend', time.getTime() - (maxTimeSmSDelay * 1000));
        }
        let lastTimeSmSSend = parseInt(localStorage.getItem('lastTimeSmSSend'), 10);
        let deltaTime = time.getTime() - lastTimeSmSSend;
        if (deltaTime < (maxTimeSmSDelay * 1000)) {
          this.smsCountdown = maxTimeSmSDelay - (Math.round(deltaTime / 1000));
          this.countdownAction();
        }
        return false;
      }
    },

  }
</script>

<style scoped>
li{list-style: none}
  .stxt li:first-child{border-bottom: 1px solid #42b983}
</style>
